import { useNavigate } from 'react-router-dom';

export default function ServicesSection() {
  const navigate = useNavigate();

  const handleServiceClick = () => {
    navigate('/projects');
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50);
  };

  const services = [
    {
      icon: 'ri-film-line',
      title: 'Filmmaking',
      description: 'Crafting immersive visual stories that pull viewers into the heart of the moment — from concept to final cut.',
    },
    {
      icon: 'ri-scissors-cut-line',
      title: 'Video Editing',
      description: 'Precision editing that shapes raw footage into compelling narratives with rhythm, pacing, and emotional impact.',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Creative Direction',
      description: 'Driving projects with a bold creative vision, merging practical insights with creative innovation.',
    },
  ];

  return (
    <section id="services" className="py-16 md:py-24 relative overflow-hidden" style={{ background: '#0f0f11' }}>
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-96 h-96" style={{ background: 'radial-gradient(circle at top right, rgba(91,138,181,0.05) 0%, transparent 60%)' }}></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-start">
          {/* Left: title */}
          <div className="self-start md:pt-[calc(4.5rem+35px)]">
            <h2 className="uppercase" style={{ fontSize: 'clamp(2.5rem, 6vw, 5rem)', lineHeight: 1.0 }}>
              <div className="text-white" style={{ fontWeight: 900 }}>Digital</div>
              <div className="text-white" style={{ fontWeight: 100 }}>Services</div>
            </h2>
          </div>

          {/* Right: services list */}
          <div className="space-y-8 md:space-y-12">
            {services.map((service, index) => (
              <div
                key={index}
                className="flex gap-6 group cursor-pointer"
                onClick={handleServiceClick}
              >
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 flex items-center justify-center">
                    <i className={`${service.icon} text-5xl text-zinc-600 group-hover:text-[#5b8ab5] transition-colors duration-300`}></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl font-black uppercase mb-3 text-white group-hover:text-[#5b8ab5] transition-colors duration-300">{service.title}</h3>
                  <p className="text-zinc-400 text-base leading-relaxed">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
